import type { ParticipantQueryParams } from "@/redux/certifications/types";
import { PAGINATION } from "@/shared/utils/constants";
import type {
  ParticipantStatusOption,
  ParticipantsTableState,
} from "@/features/certifications/participants/types";
import {
  ENROLLMENT_STATES,
  PARTICIPANT_STATUS_FILTERS,
} from "@/domains/certifications/constants";

export const STATUS_FILTERS: Record<
  ParticipantStatusOption,
  Pick<ParticipantQueryParams, "status" | "certified" | "state">
> = {
  notStarted: {
    status: PARTICIPANT_STATUS_FILTERS.NOT_STARTED,
    state: ENROLLMENT_STATES.ACTIVE,
  },
  inProgress: {
    status: PARTICIPANT_STATUS_FILTERS.IN_PROGRESS,
    state: ENROLLMENT_STATES.ACTIVE,
  },
  awaitingReview: {
    status: PARTICIPANT_STATUS_FILTERS.AWAITING_REVIEW,
    state: ENROLLMENT_STATES.ACTIVE,
  },
  certified: { certified: true, state: ENROLLMENT_STATES.ACTIVE },
  withdrawn: { state: ENROLLMENT_STATES.WITHDRAWN },
};

export const STATUS_OPTIONS = Object.keys(
  STATUS_FILTERS,
) as ParticipantStatusOption[];

export const DEFAULT_TABLE_STATE: ParticipantsTableState = {
  filters: {},
  page: PAGINATION.PAGE.DEFAULT,
  pageSize: PAGINATION.PAGE_SIZE.DEFAULT,
  ordering: "-progress",
};

export const EXPORT_MIME_TYPE = "text/csv;charset=utf-8";
